import {createAsyncThunk, createSelector, createSlice} from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import AppUtil from "../../utilities/AppUtil";

// Main URL Endpoint
const _prefix = "/specialty";

export const fetchSpecialtyPaging = createAsyncThunk(
    "specialty/fetchSpecialtyPaging",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/page`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params),
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchSpecialtyDetail = createAsyncThunk(
    "specialty/fetchSpecialtyDetail",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/detail/${params}`,
            method: "GET",
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceCreateSpecialty = createAsyncThunk(
    "specialty/reduceCreateSpecialty",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}`,
            method: "POST",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.create.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceUpdateSpecialty = createAsyncThunk(
    "specialty/reduceUpdateSpecialty",
    async (data) => {
        const result = await httpRequest({
            url: `${_prefix}/update/${data.id}`,
            method: "PUT",
            data: AppUtil.toSnakeCaseKey(data.params),
            successMessage: 'toast.update.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceDeleteSpecialty = createAsyncThunk(
    "specialty/reduceDeleteSpecialty",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/delete`,
            method: "DELETE",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.remove.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);


const initialState = {
    list: [],
    detail: {}
};

const slice = createSlice({
    name: "specialty",
    initialState: initialState,
    reducers: {
    },
    extraReducers: {
        [fetchSpecialtyPaging.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.list = payload.content;
            }
        },
        [fetchSpecialtyDetail.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.detail = payload;
            }
        }
    }
});

const { reducer } = slice;
export default reducer;

export const getSpecialtyPagingList = createSelector(
    state => state.specialty.list,
    list => list
)

export const getSpecialtyDetail = createSelector(
    state => state.specialty.detail,
    detail => detail
)
